import PropTypes from "prop-types";

const Benefits = ({
  image,
  imagePosition = "left",
  heading = "A Pinch of Health in Every Dish",
  benefits = [],
}) => {
  return (
    <section className="bg-gradient-to-r from-[#A05E2A] to-[#E7C1A6] py-14 px-4">
      <div
        className={`max-w-6xl mx-auto flex flex-col ${
          imagePosition === "left" ? "md:flex-row" : "md:flex-row-reverse"
        } gap-8 md:gap-12`}
      >
        {/* Image Section */}
        {image && (
          <div
            className={`flex items-center justify-center ${
              imagePosition === "right" ? "md:w-3/4" : "md:w-1/2"
            }`}
          >
            {typeof image === "string" ? (
              <img
                src={image}
                alt="benefit"
                className={`w-full h-auto object-contain ${
                  imagePosition === "right" ? "max-w-xl scale-110" : "max-w-md"
                }`}
              />
            ) : (
              <img
                src={image.src}
                alt={image.alt || "benefit"}
                className={`w-full h-auto object-contain ${
                  imagePosition === "right" ? "max-w-xl scale-110" : "max-w-md"
                }`}
              />
            )}
          </div>
        )}

        {/* Content Section */}
        <div className="md:w-1/2 flex flex-col justify-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-8">
            {heading}
          </h2>

          <div className="space-y-6">
            {benefits.map((benefit, index) => {
              // ✅ Allow JSX or string values
              if (typeof benefit !== "string") {
                return (
                  <div key={index} className="text-white text-lg leading-snug">
                    {benefit}
                  </div>
                );
              }

              // Default string handling
              const [title, desc] = benefit.split(" - ");
              return (
                <div key={index} className="flex items-start gap-4">
                  <svg
                    className="flex-shrink-0 w-6 h-6 text-white mt-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>

                  <p className="text-white text-lg leading-snug">
                    <span className="font-semibold">{title}</span>
                    {desc && (
                      <span className="block text-[#f5e9e1] mt-1">{desc}</span>
                    )}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

Benefits.propTypes = {
  image: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
    }),
  ]),
  imagePosition: PropTypes.oneOf(["left", "right"]),
  heading: PropTypes.string,
  benefits: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  ),
};

export default Benefits;
